import React from 'react';
import AboutUs from '../components/AboutUs'; // adjust path as necessary

const AboutUsPage = () => {
  return (
    <>
      <AboutUs />
    </>
  );
};

export default AboutUsPage;
